import accountSettingsModule from '../accountSettingsModule';

function accountTransactions(
  accountConstantsResources,
  commonConstantsService,
  cursorPaginationService
) {
  'ngInject';

  return {
    restrict: 'A',
    templateUrl: accountConstantsResources.templates.accountTransactions,
    scope: {
      paymentHistoryUrl: '@'
    },
    link(scope) {
      scope.isDataReady = false;
      scope.isLoadMoreEnabled = false;
      scope.payments = [];
      scope.errorMsg = commonConstantsService.billingHistory.historyError;
      scope.infoMsg = commonConstantsService.billingHistory.noHistory;
      scope.infoSectionCssClass = 'section-content-off';

      scope.paymentPager = cursorPaginationService.createPager({
        sortOrder: cursorPaginationService.sortOrder.Desc,
        pageSize: accountConstantsResources.paymentsPerPage,
        loadPageSize: accountConstantsResources.maxPaymentsLoaded,

        getRequestUrl() {
          return scope.paymentHistoryUrl;
        },

        getCacheKeyParameters(params) {
          // This key is use to have filters in query, and payment history don't have filter right now.
          return {};
        },

        loadSuccess(items) {
          scope.payments = scope.payments.concat(items.map(processPaymentData));
          if (scope.payments.length <= 0) {
            scope.isDataReady = false;
            scope.infoMsg = commonConstantsService.billingHistory.noHistory;
            scope.infoSectionCssClass = 'container-empty';
          } else {
            scope.isDataReady = true;
            scope.isLoadMoreEnabled = scope.paymentPager.hasNextPage();
          }
        },

        loadError() {
          const error = getErrorsFromResponseMethods();
          scope.errorMsg = error
            ? error.message
            : commonConstantsService.billingHistory.historyError;
        }
      });

      scope.loadNextPage = function() {
        if (scope.paymentPager.canLoadNextPage()) {
          scope.paymentPager.loadNextPage();
        }
      };

      if (scope.paymentHistoryUrl) {
        scope.paymentPager.setPagingParameter('index', 0);
        scope.paymentPager.loadFirstPage();
      }

      function processPaymentData(payment) {
        return {
          paymentDate: payment.paymentDate,
          amount: payment.money.Amount,
          currencySymbol: payment.money.Currency.CurrencySymbol,
          product: payment.products
            .map(function(p) {
              return p.name;
            })
            .toString(),
          paymentProvider: getPaymentProviderTypeStr(
            payment.paymentProviderType,
            payment.creditCardType
          ),
          cardNumber: getCardLastFour(payment.cardNumber)
        };
      }

      function getPaymentProviderTypeStr(paymentProviderType, creditCardType) {
        if (creditCardType) {
          return accountConstantsResources.paymentProviderTypeToClass[creditCardType];
        }
        if (paymentProviderType) {
          const paymentProviderTypeStr =
            accountConstantsResources.paymentProviderTypeToClass[paymentProviderType];
          return (
            paymentProviderTypeStr ||
            paymentProviderType.charAt(0).toLowerCase() + paymentProviderType.slice(1)
          );
        }
      }

      function getCardLastFour(maskedCardNumber) {
        return maskedCardNumber ? maskedCardNumber.substr(maskedCardNumber.length - 4) : '';
      }
    }
  };
}

accountSettingsModule.directive('accountTransactions', accountTransactions);

export default accountTransactions;
